/**
 * Get the logo URL for a given airline code or name.
 * Most logos are in GIF format and named by their 2-letter IATA code.
 * 
 * @param {string} airlineCode - The 2-letter airline code (e.g., 'AI', '6E')
 * @param {string} airlineName - The full name of the airline (optional fallback)
 * @returns {string} - The path to the airline logo
 */
export const getAirlineLogo = (airlineCode, airlineName) => {
    if (!airlineCode) return "/nologo.gif";

    const code = airlineCode.toUpperCase();

    // In a standard React app using Webpack (CRA), 
    // we can use dynamic require for assets in src/assets.
    // Note: Most files are .gif, some are .jpg or .png.
    // The following approach handles the most common case and fallbacks.

    try {
        // Attempt to load GIF (most common)
        return require(`../assets/Airline_logo/${code}.gif`);
    } catch (e1) {
        try {
            // Fallback to JPG
            return require(`../assets/Airline_logo/${code}.jpg`);
        } catch (e2) {
            try {
                // Fallback to PNG
                return require(`../assets/Airline_logo/${code}.png`);
            } catch (e3) {
                // If not found by code, we could try other patterns or return a default
                console.warn(`Logo not found for airline code: ${code}`);
                return "/nologo.gif";
            }
        }
    }
};
